var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    title: "Pause",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M4.25 1.08325H2.41667C1.91041 1.08325 1.5 1.49366 1.5 1.99992V12.9999C1.5 13.5062 1.91041 13.9166 2.41667 13.9166H4.25C4.75626 13.9166 5.16667 13.5062 5.16667 12.9999V1.99992C5.16667 1.49366 4.75626 1.08325 4.25 1.08325Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M11.5833 1.08325H9.75C9.24374 1.08325 8.83333 1.49366 8.83333 1.99992V12.9999C8.83333 13.5062 9.24374 13.9166 9.75 13.9166H11.5833C12.0896 13.9166 12.5 13.5062 12.5 12.9999V1.99992C12.5 1.49366 12.0896 1.08325 11.5833 1.08325Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.54103902d06e18955ef8f8e7bafe3601.svg";
export { ForwardRef as ReactComponent };